export const formatJson = (value: string) => {
  try {
    const parsedJson = JSON.parse(value.replaceAll("'", '"'))

    return { success: true, value: JSON.stringify(parsedJson, null, 4) }
  } catch (error) {
    return { success: false, value }
  }
}
